import apiAction from "common/redux/actions/apiAction";
import { logError } from "TAP/utils/commonMethods";
import { GET_UPG_MY_TEAM_PROFILE_FILTERS, POST_UPG_MY_PROFILE_TABLE_DATA, POST_UPG_MY_TEAM_PROFILE_POPUP_DATA_SAVE, POST_UPG_MY_TEAM_PROFILE_POPUP_FILTER_DATA } from "../apiPathConstants";


const getTeamProfileTableData = (data) => {
  return {
    type: 'GET_UPG_MY_TEAM_PROFILE_TABLE_DATA',
    payload: data
  }
};

const getTeamProfilePopUpFilterData = (data) => {
  return {
    type: 'GET_UPG_MY_TEAM_PROFILE_POPUP_FILTER_DATA',
    payload: data
  }
}

const getSaveSucessResponse = (data) => {
  return {
    type: 'UPG_MY_TEAM_PROFILE_SAVE_RESPONSE',
    payload: data
  }
}

const getMyTeamProfileFilters = (data) => {
  return {
    type: 'GET_UPG_MY_TEAM_PROFILE_FILTERS',
    payload: data
  }
}

export const MyTeamProfileTableData = (bodyData) => {
  return apiAction.postAPI({
    url: POST_UPG_MY_PROFILE_TABLE_DATA(),
    data: bodyData,
    onSuccess: getTeamProfileTableData,
    onFailure: err => logError('Error occured in fetching my team profile table  data.:', err),
    label: 'FETCH_MY_TEAM_PROFILE_TABLE_DATA',
  });
};

export const MyTeamProfilePopUpFilter = (bodyData) => {
  return apiAction.postAPI({
    url: POST_UPG_MY_TEAM_PROFILE_POPUP_FILTER_DATA(),
    data: bodyData,
    onSuccess: getTeamProfilePopUpFilterData,
    onFailure: err => logError('Error occured in fetching my team profile popup filter data.:', err),
    label: 'FETCH_MY_TEAM_PROFILE_POPUP_FILTER_DATA',

  });
}

export const MyTeamProfileSave = (bodyData) => {
  return apiAction.postAPI({
    url: POST_UPG_MY_TEAM_PROFILE_POPUP_DATA_SAVE(),
    data: bodyData,
    onSuccess: getSaveSucessResponse,
    onFailure: err => logError('Error occured in fetching my team profile popup filter data.:', err),
    label: 'FETCH_MY_TEAM_PROFILE_POPUP_FILTER_DATA',
  })
}

export const MyTeamProfileReset = (data = '') => {
   return {
    type: 'UPG_MY_TEAM_PROFILE_SAVE_RESPONSE',
    payload: data
  }
}

export const GetMyTeamProfileFilterData = (bodyData) => {
  return apiAction.postAPI({
    url: GET_UPG_MY_TEAM_PROFILE_FILTERS(),
    data: bodyData,
    onSuccess: getMyTeamProfileFilters,
    onFailure: (err) =>
      logError('Error occured in fetching filters data.:', err),
    label: 'FETCH_MY_TEAM_PROFILE_FILTER_DATA',
  });
};
